import React, { Component, Fragment } from 'react';
import { defaultDataIdFromObject } from 'apollo-cache-inmemory';
import { ApolloError } from 'apollo-client';
import gql from 'graphql-tag';
import { fromJS } from 'immutable';
import filter from 'lodash/filter';
import findIndex from 'lodash/findIndex';
import groupBy from 'lodash/groupBy';
import moment from 'moment';
import PropTypes from 'prop-types';
import { compose, graphql, withApollo } from 'react-apollo';
import { SELECTION_EVENT, trackUserEvent } from 'userActivityMiddleware';
import { SUBSCRIPTION_PREFERRED_LOCATION_CHANGED } from 'containers/DesktopNotificationTray';
import ConfirmationModal from 'components/ConfirmationModal';
import FeedList from 'components/FeedList';
import GiphyUploadModal from 'components/GiphyUploadModal';
import ImageUploadModal from 'components/ImageUploadModal';
import MessageForm from 'components/MessageForm';
import { MESSAGE_TYPE_POST } from 'components/MessageForm';
import {
  getCasinoverse,
  getSavedTab,
  turnOffCasinoverse,
  turnOnCasinoverse
} from 'utils/casinoverse';
import { CV_WEB_SOCIALPANELTABS_ENABLED } from 'utils/constants';
import { getIso9075DateString } from 'utils/dates';
import { getUserData } from 'utils/graphQLFunctions';
import fragments from 'utils/graphql/fragments';
import { USER_QUERY } from 'utils/graphql/userQueries';
import { COMMUNITY_MANAGER, isCommunityManager } from 'utils/roles';
import { userShape, wallPostShape } from 'utils/shapes';
import { replaceAllStrings } from 'utils/strings';
import {
  CASINOVERSE_FEED,
  LEGACY_FEED,
  NEWS_TAB,
  SOCIAL_TAB
} from 'utils/wall';
import './Feed.css';

// const FEED_TABS = [
//   { id: LEGACY_FEED, name: 'Legacy Feed', roles: [COMMUNITY_MANAGER] },
//   { id: NEWS_TAB, name: 'News' },
//   { id: SOCIAL_TAB, name: 'Social' },
//   { id: ALL_POSTS_TAB, name: 'All Posts' }
// ];

const TEMP_FEED_TABS = [
  { id: LEGACY_FEED, name: 'Legacy Feed', roles: [COMMUNITY_MANAGER] },
  { id: CASINOVERSE_FEED, name: 'Casinoverse Feed' }
];

class Feed extends Component {
  constructor(props) {
    super(props);

    this.state = {
      message: '',
      postsToAnimate: [],
      commentsToAnimate: [],
      showImageUploadModal: false,
      showGiphyUploadModal: false,
      showCharLimitAlertMsg: false,
      postType: '',
      messageLength: 0,
      showEmojiPicker: false,
      tab: getSavedTab(),
      filteredPosts: []
    };

    this.feedListRef = React.createRef();

    this.openUploadImageModal = this.openUploadImageModal.bind(this);
    this.closeUploadImageModal = this.closeUploadImageModal.bind(this);
    this.openUploadGiphyModal = this.openUploadGiphyModal.bind(this);
    this.closeUploadGiphyModal = this.closeUploadGiphyModal.bind(this);
    this.addComment = this.addComment.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.onSaveEditPost = this.onSaveEditPost.bind(this);
    this.handleApplyImage = this.handleApplyImage.bind(this);
    this.onSaveEditComment = this.onSaveEditComment.bind(this);
    this.onDeletePost = this.onDeletePost.bind(this);
    this.onDeleteComment = this.onDeleteComment.bind(this);
    this.onPostAnimationComplete = this.onPostAnimationComplete.bind(this);
    this.onCommentAnimationComplete =
      this.onCommentAnimationComplete.bind(this);
    this.onPinWallPost = this.onPinWallPost.bind(this);
    this.onUnpinWallPost = this.onUnpinWallPost.bind(this);
    this.onLockWallPost = this.onLockWallPost.bind(this);
    this.onUnlockWallPost = this.onUnlockWallPost.bind(this);
    this.onLikePost = this.onLikePost.bind(this);
    this.onUnlikePost = this.onUnlikePost.bind(this);
    this.onLikeComment = this.onLikeComment.bind(this);
    this.onUnlikeComment = this.onUnlikeComment.bind(this);
    this.renderPostErrorMsg = this.renderPostErrorMsg.bind(this);
    this.closePostErrorMsg = this.closePostErrorMsg.bind(this);
    this.toggleEmojiPicker = this.toggleEmojiPicker.bind(this);
    this.filterNewsPosts = this.filterNewsPosts.bind(this);
    this.handleSelectTab = this.handleSelectTab.bind(this);
    this.filterSocialPosts = this.filterSocialPosts.bind(this);
    this.addEmoji = this.addEmoji.bind(this);
    this.filterPosts = this.filterPosts.bind(this);
    this.logUserEvent = this.logUserEvent.bind(this);

    this.unsubscribeFromNewData = () => {};
  }

  componentDidMount() {
    this.unsubscribeFromNewData = this.props.subscribeToNewData(
      post => {
        this.setState({
          postsToAnimate: fromJS(this.state.postsToAnimate).push(post).toJS()
        });
      },
      comment => {
        this.setState({
          commentsToAnimate: fromJS(this.state.commentsToAnimate)
            .push(comment)
            .toJS()
        });
      }
    );
    this.unsubscribeFromRemoteConfigData =
      this.props.subscribeToRemoteConfigData();
    this.unsubscribeFromLocationData = this.props.subscribeToLocationData();
  }

  componentWillUnmount() {
    this.unsubscribeFromNewData();
    this.unsubscribeFromNewData = () => {};
    this.unsubscribeFromLocationData = () => {};
    this.unsubscribeFromRemoteConfigData = () => {};
  }

  logUserEvent(eventName, eventValue, initiator) {
    trackUserEvent({
      activityType: SELECTION_EVENT,
      eventName: eventName,
      eventValue: eventValue,
      initiator: initiator
    });
  }

  handleChange(event) {
    this.setState({
      message: event.target.value
    });
  }

  handleKeyDown(event) {
    if (event.key === 'Enter' && event.shiftKey === false) {
      this.handleSubmit(event);
    }
  }

  handleSubmit(event) {
    event.preventDefault();

    const message = this.state.message.replace(/\n\s*\n\s*\n/g, '\n\n');
    if (message.length > 4096) {
      this.setState({
        showCharLimitAlertMsg: true,
        postType: 'post',
        messageLength: message.length
      });
    } else if (message.trim()) {
      this.props.makeWallPost(message, null, null);
      this.logUserEvent('add-wall-post', message, 'wall-post-submit-button');
      this.setState({ message: '' });
      return true;
    }
    return false;
  }

  handleApplyImage(imageKey, message, imageUrl, imageAltText) {
    this.props.makeWallPost(message, imageKey, imageAltText);
  }

  addComment(postId, message) {
    message = message.replace(/\n\s*\n\s*\n/g, '\n\n');
    if (message.length > 4096) {
      this.setState({
        showCharLimitAlertMsg: true,
        postType: 'comment',
        messageLength: message.length
      });
    } else if (message.trim()) {
      this.props.makeWallComment(postId, message);
      this.logUserEvent(
        'add-wall-comment',
        'add-comment',
        'add-comment-button'
      );
      return true;
    }
    return false;
  }

  onSaveEditPost(post, message) {
    if (message.length > 4096) {
      this.setState({
        showCharLimitAlertMsg: true,
        postType: 'post',
        messageLength: message.length
      });
    } else {
      this.props.editWallPost(post, message);
      this.logUserEvent(
        'wall-feed-actions',
        'edit-post',
        'save-edit-post-button'
      );
    }
  }

  onSaveEditComment(comment, message) {
    if (message.length > 4096) {
      this.setState({
        showCharLimitAlertMsg: true,
        postType: 'comment',
        messageLength: message.length
      });
    } else {
      this.props.editComment(comment, message);
      this.logUserEvent(
        'wall-feed-actions',
        'edit-comment',
        'save-edit-comment-button'
      );
    }
  }

  onDeletePost(post) {
    this.props.deleteWallPost(post);
    this.logUserEvent('wall-feed-actions', 'delete-post', 'delete-post-button');
  }

  onDeleteComment(postId, comment) {
    this.props.deleteWallComment(postId, comment);
    this.logUserEvent(
      'wall-feed-actions',
      'delete-comment',
      'delete-comment-button'
    );
  }

  closeUploadGiphyModal() {
    this.setState({ showGiphyUploadModal: false });
    this.logUserEvent('add-gif-modal', 'close', 'close-gif-button');
  }

  openUploadGiphyModal() {
    this.setState({ showGiphyUploadModal: true });
    this.logUserEvent('open-add-gif-modal', 'open', 'add-gif-button');
  }

  closeUploadImageModal() {
    this.setState({ showImageUploadModal: false });
    this.logUserEvent(
      'close-add-picture-modal',
      'close',
      'close-picture-button'
    );
  }

  openUploadImageModal(event) {
    event.preventDefault();
    this.setState({ showImageUploadModal: true });
    this.logUserEvent('open-add-picture-modal', 'open', 'add-picture-button');
  }

  onPostAnimationComplete(post) {
    this.setState({
      postsToAnimate: filter(this.state.postsToAnimate, item => {
        return post.id !== item.id;
      })
    });
  }

  onCommentAnimationComplete(comment) {
    this.setState({
      commentsToAnimate: fromJS(this.state.commentsToAnimate)
        .filter(item => {
          return comment.id !== item.get('id');
        })
        .toJS()
    });
  }

  onPinWallPost(post) {
    this.props.pinWallPost(post);
    this.logUserEvent('wall-feed-actions', 'pin', 'wall-pin-post-button');
  }

  onUnpinWallPost(post) {
    this.props.unpinWallPost(post);
    this.logUserEvent('wall-feed-actions', 'unpin', 'wall-unpin-post-button');
  }

  onLockWallPost(post) {
    this.props.lockWallPost(post);
    this.logUserEvent('wall-feed-actions', 'lock', 'wall-lock-post-button');
  }

  onUnlockWallPost(post) {
    this.props.unlockWallPost(post);
    this.logUserEvent('wall-feed-actions', 'unlock', 'wall-unlock-post-button');
  }

  onLikePost(post) {
    this.props.likePost(post);
    this.logUserEvent('wall-feed-actions', 'like', 'wall-like-post-button');
  }

  onUnlikePost(post) {
    this.props.unlikePost(post);
    this.logUserEvent('wall-feed-actions', 'unlike', 'wall-unlike-post-button');
  }

  onLikeComment(comment) {
    this.props.likeComment(comment);
    this.logUserEvent(
      'wall-feed-actions',
      'unlike',
      'wall-like-comment-button'
    );
  }

  onUnlikeComment(comment) {
    this.props.unlikeComment(comment);
    this.logUserEvent(
      'wall-feed-actions',
      'unlike',
      'wall-unlike-comment-button'
    );
  }

  toggleEmojiPicker() {
    const isEmoji = this.state.showEmojiPicker;
    this.setState({
      showEmojiPicker: !isEmoji
    });
  }

  addEmoji(emoji) {
    const { message } = this.state;
    const text = `${message}${emoji.native}`;

    this.setState({
      message: text
    });
  }

  renderPostErrorMsg() {
    return (
      <ConfirmationModal
        onSelection={this.closePostErrorMsg}
        cancelText="Cancel"
        show={this.state.showCharLimitAlertMsg}
        title="Alert"
      >
        <p>
          Sorry, your {this.state.postType} is too long!
          <br />
          Your {this.state.postType} is {this.state.messageLength} characters
          long. The max {this.state.postType} length is 4096 characters.
        </p>
      </ConfirmationModal>
    );
  }

  closePostErrorMsg() {
    this.setState({ showCharLimitAlertMsg: false });
  }

  filterByTab = posts => {
    const { showLegacyFeed } = this.props;
    const { tab } = this.state;

    //TODO: social Tabs remote config - add back remoteConfigData to props
    // const {
    //   loading = false,
    //   remoteConfigEntry = {},
    // } = remoteConfigData;
    // const {
    //   key: remoteConfigKey,
    //   value: remoteConfigValue,
    // } = remoteConfigEntry;
    // const socialPanelTabsEnabled =
    //   !loading &&
    //   remoteConfigKey === CV_WEB_SOCIALPANELTABS_ENABLED &&
    //   remoteConfigValue;

    if (showLegacyFeed || tab === CASINOVERSE_FEED) {
      return posts;
    } else if (tab === NEWS_TAB) {
      return this.filterNewsPosts(posts);
    } else if (tab === SOCIAL_TAB) {
      return this.filterSocialPosts(posts);
    } else {
      return [];
    }
  };

  filterPostsByLocation = (preferredLocation, posts) => {
    if (!preferredLocation) {
      return posts;
    }

    const locationId =
      preferredLocation.slice(0, 1).toLowerCase() +
      replaceAllStrings(preferredLocation.slice(1), ' ', '');

    return posts.filter(({ isSystemPost, message }) => {
      if (!isSystemPost) {
        return true;
      }
      try {
        const { locations } = JSON.parse(message);
        return !Array.isArray(locations) || locations.includes(locationId);
      } catch {
        return false;
      }
    });
  };

  filterNewsPosts(posts) {
    return posts?.filter(
      ({ isSystemPost, isPinned }) => isSystemPost || isPinned
    );
  }

  filterSocialPosts(posts) {
    return posts?.filter(
      ({ isSystemPost, isPinned }) => !isSystemPost || isPinned
    );
  }

  filterPosts() {
    const { userData, postData } = this.props;
    const { posts = [] } = postData?.posts ?? {};
    const { user } = userData || {};
    const { preferredLocation } = user || {};
    const { tab } = this.state;

    // If LEGACY_FEED is selected return all 2.0 wall posts
    if (tab === LEGACY_FEED) {
      return posts;
    }

    const locationPosts = this.filterPostsByLocation(preferredLocation, posts);
    return this.filterByTab(locationPosts);
  }

  handleSelectTab = tab => {
    if (this.feedListRef.current && this.feedListRef.current.scrollTop) {
      this.feedListRef.current.scrollTop = 0;
    }

    const casinoverseOn = getCasinoverse();

    if (tab === LEGACY_FEED) {
      if (casinoverseOn) {
        turnOffCasinoverse();
      }
    } else {
      if (!casinoverseOn) {
        turnOnCasinoverse(tab);
      }
    }

    this.setState({ tab });
    this.logUserEvent('select-feed-tab-types', tab, 'feed-tabs');
  };

  renderFeedTabs = () => {
    const {
      showLegacyFeed,
      userData: { user }
    } = this.props;
    const { tab } = this.state;

    //TODO: social Tabs remote config - add back remoteConfigData to props
    // const {
    //   loading = false,
    //   remoteConfigEntry = {},
    // } = remoteConfigData;
    // const {
    //   key: remoteConfigKey,
    //   value: remoteConfigValue,
    // } = remoteConfigEntry;
    // const socialPanelTabsEnabled =
    //   !loading &&
    //   remoteConfigKey === CV_WEB_SOCIALPANELTABS_ENABLED &&
    //   remoteConfigValue;

    if (showLegacyFeed || !isCommunityManager(user)) {
      return null;
    }

    const visibleTabs = TEMP_FEED_TABS.filter(tab => {
      return !tab.roles || tab.roles?.some(role => user?.roles.includes(role));
    });

    return (
      <ul className="nav nav-pills nav-fill nav-tabs">
        {visibleTabs.map(({ id, name }) => (
          <li key={`nav-tabs-feed-${id}`} className="nav-item">
            <button
              className={`nav-link${tab === id ? ' active' : ''}`}
              type="button"
              onClick={() => this.handleSelectTab(id)}
              {...(this.state.tab === id && { 'aria-current': 'page' })}
            >
              {name}
            </button>
          </li>
        ))}
      </ul>
    );
  };

  render() {
    const {
      narrow,
      userData,
      postData,
      hidePostForm,
      homeLayoutUpdateEnabled,
      showLegacyFeed
    } = this.props;
    const { showEmojiPicker } = this.state;

    // TODO: social tabs remote config - add remoteConfigData back to props
    // const { loading, remoteConfigEntry } = remoteConfigData || {};
    // const { key, value } = remoteConfigEntry || {};
    // const socialPanelTabsEnabled = !loading && key === CV_WEB_SOCIALPANELTABS_ENABLED && value;

    const communityManagerTabsEnabled = isCommunityManager(userData.user);
    const filterdPosts = this.filterPosts();
    const feedType = showLegacyFeed ? 'legacy-feed' : 'feed';
    const homeLayout =
      homeLayoutUpdateEnabled && !showLegacyFeed ? 'update-home-layout' : '';

    return (
      <div className={`${feedType} ${homeLayout}`}>
        <div className={`feed-wrapper ${narrow ? 'narrow' : ''}`}>
          {this.renderFeedTabs()}
          {!hidePostForm && (
            <Fragment>
              <div
                className={`feed-comment-container initial-comment${
                  communityManagerTabsEnabled ? '' : ' no-tab'
                }`}
              >
                <MessageForm
                  showLegacyFeed={showLegacyFeed}
                  onSubmit={this.handleSubmit}
                  onChange={this.handleChange}
                  onKeyDown={this.handleKeyDown}
                  onAddImageClick={this.openUploadImageModal}
                  onAddGiphyClick={this.openUploadGiphyModal}
                  onEmojiPicker={this.toggleEmojiPicker}
                  message={this.state.message}
                  placeholder={MESSAGE_TYPE_POST}
                  showEmojiPicker={showEmojiPicker}
                  addEmoji={this.addEmoji}
                />
              </div>
              <GiphyUploadModal
                show={this.state.showGiphyUploadModal}
                onHide={this.closeUploadGiphyModal}
                applyGiphy={this.handleApplyImage}
                includeComment={true}
                resourcePath={'/uploadFromUrl'}
                user={userData.user}
              />
              <ImageUploadModal
                show={this.state.showImageUploadModal}
                onHide={this.closeUploadImageModal}
                applyImage={this.handleApplyImage}
                resourcePath={'/uploadWallImage'}
                includeComment={true}
                user={userData.user}
              />
            </Fragment>
          )}
          <div className="feed-list-container" ref={this.feedListRef}>
            {postData && (
              <FeedList
                showLegacyFeed={showLegacyFeed}
                user={userData.user}
                posts={filterdPosts}
                loading={postData.loading || userData.loading}
                error={postData.error || userData.error}
                addComment={this.addComment}
                onSaveEditPost={this.onSaveEditPost}
                onSaveEditComment={this.onSaveEditComment}
                onDeletePost={this.onDeletePost}
                onDeleteComment={this.onDeleteComment}
                loadMorePosts={this.props.loadMorePosts}
                loadMoreComments={this.props.loadMoreComments}
                hasAnyMore={!!postData.posts && postData.posts.hasAnyNext}
                postsToAnimate={this.state.postsToAnimate}
                onPostAnimationComplete={this.onPostAnimationComplete}
                commentsToAnimate={this.state.commentsToAnimate}
                onCommentAnimationComplete={this.onCommentAnimationComplete}
                onPinWallPost={this.onPinWallPost}
                onUnpinWallPost={this.onUnpinWallPost}
                onLockWallPost={this.onLockWallPost}
                onUnlockWallPost={this.onUnlockWallPost}
                onLikePost={this.onLikePost}
                onUnlikePost={this.onUnlikePost}
                onLikeComment={this.onLikeComment}
                onUnlikeComment={this.onUnlikeComment}
              />
            )}
          </div>
        </div>
        {this.renderPostErrorMsg()}
      </div>
    );
  }
}

Feed.defaultProps = {
  showLegacyFeed: false,
  hidePostForm: false,
  narrow: false
};

Feed.propTypes = {
  narrow: PropTypes.bool,
  userData: PropTypes.shape({
    user: userShape,
    loading: PropTypes.bool,
    error: PropTypes.oneOfType([
      PropTypes.instanceOf(Error),
      PropTypes.instanceOf(ApolloError)
    ])
  }),
  postData: PropTypes.shape({
    loading: PropTypes.bool,
    error: PropTypes.oneOfType([
      PropTypes.instanceOf(Error),
      PropTypes.instanceOf(ApolloError)
    ]),
    posts: PropTypes.shape({
      posts: PropTypes.arrayOf(wallPostShape),
      startPostId: PropTypes.number,
      endPostId: PropTypes.number,
      hasAnyNext: PropTypes.bool
    })
  }),
  subscribeToNewData: PropTypes.func,
  showLegacyFeed: PropTypes.bool
};

const QUERY_WALL_POSTS = gql`
  query MyGetPostsWithComments($posts: GetPosts!, $comments: GetComments!) {
    posts(posts: $posts) {
      posts {
        ...PostWithComments
      }
      ...PostPaginationFields
    }
  }
  ${fragments.postPagination}
  ${fragments.postWithComments}
`;

const QUERY_WALL_POSTS_DEFAULT_VARS = {
  posts: { postCount: 10, mostRecentLikedByCount: 10 },
  comments: { commentCount: 10, mostRecentLikedByCount: 10 }
};

const QUERY_WALL_COMMENTS = gql`
  query MyGetPostComments($comments: GetComments!) {
    comments(comments: $comments) {
      comments {
        ...CommentFields
      }
      ...CommentPaginationFields
    }
  }
  ${fragments.comment}
  ${fragments.commentPagination}
`;

const MUTATION_MAKE_WALL_POST = gql`
  mutation MyMakePost($post: MakePost!, $posts: GetPosts!) {
    makePost(post: $post) {
      ...PostFields
    }
  }
  ${fragments.post}
`;

const MUTATUION_EDIT_WALL_POST = gql`
  mutation MyEditPost($post: EditPost!, $posts: GetPosts!) {
    editPost(post: $post) {
      ...PostFields
    }
  }
  ${fragments.post}
`;

const MUTATION_DELETE_WALL_POST = gql`
  mutation MyDeletePost($post: DeletePost!) {
    deletePost(post: $post) {
      id
    }
  }
`;

const MUTATION_MAKE_WALL_COMMENT = gql`
  mutation MyMakeComment($comment: MakeComment!, $comments: GetComments!) {
    makeComment(comment: $comment) {
      ...CommentFields
    }
  }
  ${fragments.comment}
`;

const MUTATION_EDIT_WALL_COMMENT = gql`
  mutation MyEditComment($comment: EditComment!, $comments: GetComments!) {
    editComment(comment: $comment) {
      ...CommentFields
    }
  }
  ${fragments.comment}
`;

const MUTATION_DELETE_WALL_COMMENT = gql`
  mutation MyDeletePostComment($comment: DeleteComment!) {
    deleteComment(comment: $comment) {
      id
      postId
    }
  }
`;

const MUTATION_PIN_WALL_POST = gql`
  mutation MyPinPost($post: PinPost!, $posts: GetPosts!) {
    pinPost(post: $post) {
      post {
        ...PostFields
      }
    }
  }
  ${fragments.post}
`;

const MUTATION_UNPIN_WALL_POST = gql`
  mutation MyUnpinPost($post: UnpinPost!) {
    unpinPost(post: $post) {
      id
    }
  }
`;

const MUTATION_LOCK_WALL_POST = gql`
  mutation MyLockPost($post: LockPost!, $posts: GetPosts!) {
    lockPost(post: $post) {
      post {
        ...PostFields
      }
    }
  }
  ${fragments.post}
`;

const MUTATION_UNLOCK_WALL_POST = gql`
  mutation MyUnlockPost($post: UnlockPost!) {
    unlockPost(post: $post) {
      id
    }
  }
`;

const MUTATION_LIKE_WALL_POST = gql`
  mutation MyLikePost($like: LikePost!) {
    likePost(like: $like) {
      id
    }
  }
`;

const MUTATION_UNLIKE_WALL_POST = gql`
  mutation MyUnlikePost($unlike: UnlikePost!) {
    unlikePost(unlike: $unlike) {
      id
    }
  }
`;

const MUTATION_LIKE_COMMENT = gql`
  mutation MyLikeComment($like: LikeComment!) {
    likeComment(like: $like) {
      id
      postId
    }
  }
`;

const MUTATION_UNLIKE_COMMENT = gql`
  mutation MyUnikeComment($unlike: UnlikeComment!) {
    unlikeComment(unlike: $unlike) {
      id
      postId
    }
  }
`;

const SUBSCRIPTION_WALL_UPDATES = gql`
  subscription WallUpdates($posts: GetPosts!, $comments: GetComments!) {
    wallUpdates {
      posts {
        ...PostWithComments
      }
      comments {
        ...CommentFields
      }
      editedPosts {
        post {
          ...PostWithComments
        }
      }
      editedComments {
        comment {
          ...CommentFields
        }
      }
      deletedPosts {
        id
      }
      deletedComments {
        id
        postId
      }
      pinnedPosts {
        post {
          ...PostWithComments
        }
      }
      unpinnedPosts {
        id
      }
      lockedPosts {
        post {
          ...PostWithComments
        }
      }
      unlockedPosts {
        id
      }
      likedPosts {
        id
        likedBy {
          ...UserIdAndDisplayFields
        }
      }
      unlikedPosts {
        id
        userId
      }
      likedComments {
        id
        postId
        likedBy {
          ...UserIdAndDisplayFields
        }
      }
      unlikedComments {
        id
        postId
        userId
      }
    }
  }
  ${fragments.postWithComments}
  ${fragments.comment}
`;

const QUERY_GET_REMOTE_CONFIG_ENTRY = gql`
  query RemoteConfigEntry($key: String!) {
    remoteConfigEntry(key: $key) {
      key
      value
    }
  }
`;

const REMOTE_CONFIG_EVENT = gql`
  subscription remoteConfigEvent {
    remoteConfigEvent {
      action
      entries {
        key
        value
      }
    }
  }
`;

export default withApollo(
  compose(
    // User data must be composed before makeWallPost mutation.
    getUserData({
      name: 'userData'
    }),
    graphql(QUERY_WALL_POSTS, {
      name: 'postData',
      options: {
        variables: QUERY_WALL_POSTS_DEFAULT_VARS,
        fetchPolicy: 'cache-and-network',
        notifyOnNetworkStatusChange: true
      },
      props({ ownProps, postData }) {
        return {
          postData,
          loadMorePosts: () => {
            return postData.fetchMore({
              query: QUERY_WALL_POSTS,
              variables: {
                posts: {
                  postCount: 10,
                  beforeId: postData.posts.endId,
                  mostRecentLikedByCount: 10
                },
                comments: {
                  commentCount: 10,
                  mostRecentLikedByCount: 10
                }
              },
              updateQuery: (previousResult, { fetchMoreResult }) => {
                if (!fetchMoreResult) {
                  return null;
                }
                return fromJS(fetchMoreResult)
                  .updateIn(['posts', 'posts'], list =>
                    fromJS(previousResult.posts.posts).concat(list)
                  )
                  .toJS();
              }
            });
          },
          loadMoreComments: (post, count, callback) => {
            return postData.fetchMore({
              query: QUERY_WALL_COMMENTS,
              variables: {
                comments: {
                  commentCount: count,
                  beforeId: post.comments.endId,
                  postId: post.id,
                  mostRecentLikedByCount: 10
                }
              },
              updateQuery: (previousResult, { fetchMoreResult }) => {
                const postIdx = findIndex(
                  previousResult.posts.posts,
                  item => item.id === post.id
                );

                callback(fetchMoreResult.comments.comments.length);

                return fromJS(previousResult)
                  .updateIn(['posts', 'posts', postIdx, 'comments'], item => {
                    return item
                      .update('comments', list => {
                        return list.concat(
                          fromJS(fetchMoreResult.comments.comments)
                        );
                      })
                      .set('endId', fetchMoreResult.comments.endId)
                      .set('hasAnyNext', fetchMoreResult.comments.hasAnyNext);
                  })
                  .toJS();
              }
            });
          },
          subscribeToNewData: (onNewPost, onNewComment) => {
            return postData.subscribeToMore({
              document: SUBSCRIPTION_WALL_UPDATES,
              variables: QUERY_WALL_POSTS_DEFAULT_VARS,
              updateQuery: (prev, { subscriptionData }) => {
                const {
                  posts,
                  comments,
                  editedPosts,
                  editedComments,
                  deletedPosts,
                  deletedComments,
                  pinnedPosts,
                  unpinnedPosts,
                  lockedPosts,
                  unlockedPosts,
                  likedPosts,
                  unlikedPosts,
                  likedComments,
                  unlikedComments
                } = subscriptionData.data;
                let newData = fromJS(prev);

                const { user } = ownProps.client.readQuery({
                  query: USER_QUERY
                });

                // Check for updated posts.
                if (posts && posts.length > 0) {
                  const newPosts = filter(
                    posts,
                    post =>
                      !prev.posts.posts.find(p => p.id === post.id) &&
                      post.author
                  );
                  if (newPosts.length > 0) {
                    onNewPost && newPosts.forEach(onNewPost);
                    newData = newData.updateIn(['posts', 'posts'], list =>
                      fromJS(newPosts).concat(list)
                    );
                  }
                }

                // Check for updated comments.
                if (comments && comments.length > 0) {
                  const postComments = groupBy(comments, 'postId');
                  newData = newData.updateIn(['posts', 'posts'], list =>
                    list.map(post => {
                      if (!postComments[post.get('id')]) {
                        return post;
                      }

                      const curComments = post.getIn(['comments', 'comments']);
                      const newComments = filter(
                        postComments[post.get('id')],
                        comment =>
                          !curComments.find(c => c.get('id') === comment.id) &&
                          comment.author
                      ).map(newComment =>
                        Object.assign({}, newComment, {
                          likeCount: 0,
                          likedByMe: false
                        })
                      );
                      if (newComments.length > 0) {
                        onNewComment && newComments.forEach(onNewComment);
                        return post
                          .updateIn(['comments', 'comments'], list =>
                            fromJS(newComments).concat(list)
                          )
                          .set(
                            'commentCount',
                            post.get('commentCount') + newComments.length
                          );
                      }

                      return post;
                    })
                  );
                }

                //Check for edited posts.
                if (editedPosts && editedPosts.length > 0) {
                  const editedPostIds = editedPosts.map(
                    editedPost => editedPost.post.id
                  );
                  newData = newData.updateIn(['posts', 'posts'], list => {
                    return list.map(post => {
                      if (editedPostIds.includes(post.get('id'))) {
                        const editedPost = editedPosts.find(
                          editedPost => editedPost.post.id === post.get('id')
                        );

                        return post
                          .set('message', editedPost.post.message)
                          .set('lastEditedAt', editedPost.post.lastEditedAt);
                      } else {
                        return post;
                      }
                    });
                  });
                }

                //Check for edited comments.
                if (editedComments && editedComments.length > 0) {
                  const postEditedComments = groupBy(
                    editedComments,
                    'comment.postId'
                  );
                  newData = newData.updateIn(['posts', 'posts'], list => {
                    return list.map(post => {
                      if (postEditedComments[post.get('id')]) {
                        return post.updateIn(
                          ['comments', 'comments'],
                          commentsList => {
                            const editedCommentIds = postEditedComments[
                              post.get('id')
                            ].map(comment => comment.comment.id);

                            return commentsList.map(comment => {
                              if (
                                editedCommentIds.includes(comment.get('id'))
                              ) {
                                const editedComment = editedComments.find(
                                  editedComment =>
                                    editedComment.comment.id ===
                                    comment.get('id')
                                );

                                return comment
                                  .set('comment', editedComment.comment.comment)
                                  .set(
                                    'lastEditedAt',
                                    editedComment.comment.lastEditedAt
                                  );
                              } else {
                                return comment;
                              }
                            });
                          }
                        );
                      } else {
                        return post;
                      }
                    });
                  });
                }

                // Check for liked posts.
                if (likedPosts && likedPosts.length > 0) {
                  const likedPostIds = likedPosts.map(post => post.id);
                  newData = newData.updateIn(['posts', 'posts'], list => {
                    return list.map(post => {
                      if (likedPostIds.includes(post.get('id'))) {
                        const likedPost = likedPosts.find(
                          likedPost => likedPost.id === post.get('id')
                        );
                        const alreadyLikedByMe = post.get('likedByMe');
                        const likedByMe =
                          likedPost.likedBy.userId === user.userId;

                        return post
                          .update('likeCount', count =>
                            alreadyLikedByMe && likedByMe ? count : count + 1
                          )
                          .set('likedByMe', alreadyLikedByMe || likedByMe)
                          .update('likedBy', lb =>
                            alreadyLikedByMe && likedByMe
                              ? lb
                              : lb.concat(likedPost.likedBy)
                          )
                          .toJS();
                      } else {
                        return post;
                      }
                    });
                  });
                }

                // Check for unliked posts.
                if (unlikedPosts && unlikedPosts.length > 0) {
                  const unlikedPostIds = unlikedPosts.map(post => post.id);
                  newData = newData.updateIn(['posts', 'posts'], list => {
                    return list.map(post => {
                      if (unlikedPostIds.includes(post.get('id'))) {
                        const unlikedPost = unlikedPosts.find(
                          unlikedPost => unlikedPost.id === post.get('id')
                        );
                        const unlikedAccount = unlikedPost.userId;

                        const alreadyLikedByMe = post.get('likedByMe');
                        const unlikedByMe = unlikedAccount === user.userId;

                        return post
                          .update('likeCount', count =>
                            alreadyLikedByMe || !unlikedByMe ? count - 1 : count
                          )
                          .set('likedByMe', alreadyLikedByMe && !unlikedByMe)
                          .update('likedBy', lb =>
                            lb.filter(u => u.get('userId') !== unlikedAccount)
                          )
                          .toJS();
                      } else {
                        return post;
                      }
                    });
                  });
                }

                // Check for deleted posts.
                if (deletedPosts && deletedPosts.length > 0) {
                  const deletedPostIds = deletedPosts.map(post => post.id);
                  newData = newData.updateIn(['posts', 'posts'], list =>
                    list.filter(
                      post => !deletedPostIds.includes(post.get('id'))
                    )
                  );

                  // Check if startId is one of the deleted posts, if it is then set startId to be first post.
                  if (
                    deletedPostIds.includes(newData.getIn(['posts', 'endId']))
                  ) {
                    newData = newData.setIn(
                      ['posts', 'startId'],
                      newData.getIn(['posts', 'posts']).count() > 0
                        ? newData.getIn(['posts', 'posts']).first().get('id')
                        : ''
                    );
                  }

                  // Check if endId is one of the deleted posts, if it is then set endId to be last post.
                  if (
                    deletedPostIds.includes(newData.getIn(['posts', 'endId']))
                  ) {
                    newData = newData.setIn(
                      ['posts', 'endId'],
                      newData.getIn(['posts', 'posts']).count() > 0
                        ? newData.getIn(['posts', 'posts']).last().get('id')
                        : ''
                    );
                  }
                }

                // Check for liked comments.
                if (likedComments && likedComments.length > 0) {
                  const postLikedComments = groupBy(likedComments, 'postId');
                  newData = newData.updateIn(['posts', 'posts'], list => {
                    return list.map(post => {
                      if (postLikedComments[post.get('id')]) {
                        return post.updateIn(
                          ['comments', 'comments'],
                          commentsList => {
                            const likedCommentIds = postLikedComments[
                              post.get('id')
                            ].map(comment => comment.id);

                            return commentsList.map(comment => {
                              if (likedCommentIds.includes(comment.get('id'))) {
                                const likedComment = likedComments.find(
                                  likedComment =>
                                    likedComment.id === comment.get('id')
                                );

                                const alreadyLikedByMe =
                                  comment.get('likedByMe');
                                const likedByMe =
                                  likedComment.likedBy.userId === user.userId;
                                const likeCount = comment.get('likeCount');

                                return comment
                                  .set(
                                    'likeCount',
                                    alreadyLikedByMe && likedByMe
                                      ? likeCount
                                      : likeCount + 1
                                  )
                                  .set(
                                    'likedByMe',
                                    alreadyLikedByMe || likedByMe
                                  )
                                  .update('likedBy', lb =>
                                    alreadyLikedByMe && likedByMe
                                      ? lb
                                      : lb.concat(likedComment.likedBy)
                                  );
                              } else {
                                return comment;
                              }
                            });
                          }
                        );
                      } else {
                        return post;
                      }
                    });
                  });
                }

                // Check for unliked comments.
                if (unlikedComments && unlikedComments.length > 0) {
                  const postUnlikedComments = groupBy(
                    unlikedComments,
                    'postId'
                  );
                  newData = newData.updateIn(['posts', 'posts'], list => {
                    return list.map(post => {
                      if (postUnlikedComments[post.get('id')]) {
                        return post.updateIn(
                          ['comments', 'comments'],
                          commentsList => {
                            const unlikedCommentIds = postUnlikedComments[
                              post.get('id')
                            ].map(comment => comment.id);

                            return commentsList.map(comment => {
                              if (
                                unlikedCommentIds.includes(comment.get('id'))
                              ) {
                                const unlikedComment = unlikedComments.find(
                                  unlikedComment =>
                                    unlikedComment.id === comment.get('id')
                                );

                                const alreadyLikedByMe =
                                  comment.get('likedByMe');
                                const unlikedByMe =
                                  unlikedComment.userId === user.userId;
                                const likeCount = comment.get('likeCount');

                                return comment
                                  .set(
                                    'likeCount',
                                    alreadyLikedByMe || !unlikedByMe
                                      ? likeCount - 1
                                      : likeCount
                                  )
                                  .set(
                                    'likedByMe',
                                    alreadyLikedByMe && !unlikedByMe
                                  )
                                  .update('likedBy', lb =>
                                    lb.filter(
                                      u =>
                                        u.get('userId') !==
                                        unlikedComment.userId
                                    )
                                  );
                              } else {
                                return comment;
                              }
                            });
                          }
                        );
                      } else {
                        return post;
                      }
                    });
                  });
                }

                // Check for deleted comments.
                if (deletedComments && deletedComments.length > 0) {
                  const postDeletedComments = groupBy(
                    deletedComments,
                    'postId'
                  );
                  newData = newData.updateIn(['posts', 'posts'], list =>
                    list.map(post => {
                      if (postDeletedComments[post.get('id')]) {
                        const commentsToDelete = filter(
                          postDeletedComments[post.get('id')],
                          comment =>
                            !!post
                              .getIn(['comments', 'comments'])
                              .find(match => match.get('id') === comment.id)
                        );
                        const deletedCommentIds = commentsToDelete.map(
                          comment => comment.id
                        );
                        let newPost = post
                          .updateIn(['comments', 'comments'], list =>
                            list.filter(
                              comment =>
                                !deletedCommentIds.includes(comment.get('id'))
                            )
                          )
                          .set(
                            'commentCount',
                            post.get('commentCount') - deletedCommentIds.length
                          );

                        if (
                          deletedCommentIds.includes(
                            newPost.getIn(['comments', 'startId'])
                          )
                        ) {
                          newPost = newPost.setIn(
                            ['comments', 'startId'],
                            newPost.getIn(['comments', 'comments']).count() > 0
                              ? newPost
                                  .getIn(['comments', 'comments'])
                                  .first()
                                  .get('id')
                              : ''
                          );
                        }

                        // Check if endId is one of the deleted comments, if it is then set endId to be last comment.
                        if (
                          deletedCommentIds.includes(
                            newPost.getIn(['comments', 'endId'])
                          )
                        ) {
                          newPost = newPost.setIn(
                            ['comments', 'endId'],
                            newPost.getIn(['comments', 'comments']).count() > 0
                              ? newPost
                                  .getIn(['comments', 'comments'])
                                  .last()
                                  .get('id')
                              : ''
                          );
                        }

                        return newPost;
                      }

                      return post;
                    })
                  );
                }

                // Check if new pinned posts.
                if (pinnedPosts && pinnedPosts.length > 0) {
                  let pinnedPostIds = pinnedPosts.map(
                    pinnedPost => pinnedPost.post.id
                  );
                  newData = newData.updateIn(['posts', 'posts'], list => {
                    const newUnpinnedPosts = list.filter(
                      post => !pinnedPostIds.includes(post.get('id'))
                    );

                    // Insert newly pinned posts at the front of the list
                    const newPinnedPosts = pinnedPosts.map(
                      pinnedPost => pinnedPost.post
                    );
                    return fromJS(newPinnedPosts).concat(newUnpinnedPosts);
                  });
                }

                // Check if unpinned posts.
                if (unpinnedPosts && unpinnedPosts.length > 0) {
                  const unpinnedPostIds = unpinnedPosts.map(post => post.id);
                  newData = newData.updateIn(['posts', 'posts'], list =>
                    list.map(post => {
                      return unpinnedPostIds.includes(post.get('id'))
                        ? post.set('isPinned', false)
                        : post;
                    })
                  );

                  newData = newData.updateIn(['posts', 'posts'], list => {
                    const unpinnedPost = unpinnedPostIds
                      ? list.find(post => post.get('id') === unpinnedPostIds[0])
                      : null;
                    const olderPosts = list.filter(post => {
                      return (
                        new Date(post.get('created')) <
                        new Date(unpinnedPost.get('created'))
                      );
                    });
                    const newerPosts = list.filter(post => {
                      return (
                        new Date(post.get('created')) >
                        new Date(unpinnedPost.get('created'))
                      );
                    });

                    if (olderPosts.length > 0) {
                      const newList = [
                        ...newerPosts.toJS(),
                        unpinnedPost,
                        ...olderPosts.toJS()
                      ];

                      return fromJS(newList);
                    } else {
                      return list;
                    }
                  });
                }

                // Check if locked posts
                if (lockedPosts && lockedPosts.length > 0) {
                  const lockedPostIds = lockedPosts.map(
                    lockedPost => lockedPost.post.id
                  );
                  newData = newData.updateIn(['posts', 'posts'], list =>
                    list.map(post => {
                      return lockedPostIds.includes(post.get('id'))
                        ? post.set('isLocked', true)
                        : post;
                    })
                  );
                }

                // Check if unlocked posts
                if (unlockedPosts && unlockedPosts.length > 0) {
                  const unlockedPostIds = unlockedPosts.map(post => post.id);
                  newData = newData.updateIn(['posts', 'posts'], list =>
                    list.map(post => {
                      return unlockedPostIds.includes(post.get('id'))
                        ? post.set('isLocked', false)
                        : post;
                    })
                  );
                }

                return newData.toJS();
              }
            });
          },
          subscribeToLocationData: () => {
            return postData.subscribeToMore({
              document: SUBSCRIPTION_PREFERRED_LOCATION_CHANGED,
              updateQuery: () => postData.refetch()
            });
          }
        };
      }
    }),
    graphql(MUTATION_MAKE_WALL_POST, {
      props({ ownProps, mutate }) {
        return {
          makeWallPost: (message, imageKey, imageAltText) => {
            return mutate({
              variables: {
                post: {
                  message: message || null,
                  imageKey: imageKey || null,
                  imageAltText: imageAltText || null
                },
                posts: {
                  postCount: 1
                },
                comments: {
                  commentCount: 1
                }
              }
            });
          }
        };
      }
    }),
    graphql(MUTATUION_EDIT_WALL_POST, {
      props({ ownProps, mutate }) {
        return {
          editWallPost: (post, message) => {
            return mutate({
              variables: {
                post: {
                  id: post.id,
                  message: message
                },
                posts: {
                  postCount: 1
                },
                comments: null
              },
              optimisticResponse: {
                editPost: {
                  ...post,
                  message: message,
                  lastEditedAt: getIso9075DateString(moment.utc()),
                  id: post.id,
                  __typename: 'Post'
                }
              }
            });
          }
        };
      }
    }),
    graphql(MUTATION_DELETE_WALL_POST, {
      props({ ownProps, mutate }) {
        return {
          deleteWallPost: post => {
            return mutate({
              variables: { post: { id: post.id } }
            });
          }
        };
      }
    }),
    graphql(MUTATION_MAKE_WALL_COMMENT, {
      props({ ownProps, mutate }) {
        return {
          makeWallComment: (postId, comment) => {
            return mutate({
              variables: {
                comment: { postId, comment },
                comments: { commentCount: 1 }
              }
            });
          }
        };
      }
    }),
    graphql(MUTATION_EDIT_WALL_COMMENT, {
      props({ ownProps, mutate }) {
        return {
          editComment: (comment, message) => {
            return mutate({
              variables: {
                comment: {
                  id: comment.id,
                  postId: comment.postId,
                  message: message
                },
                comments: {
                  commentCount: 1
                },
                posts: null
              },
              optimisticResponse: {
                editComment: {
                  ...comment,
                  comment: message,
                  lastEditedAt: getIso9075DateString(moment.utc()),
                  id: comment.id,
                  __typename: 'Comment'
                }
              }
            });
          }
        };
      }
    }),
    graphql(MUTATION_DELETE_WALL_COMMENT, {
      props({ ownProps, mutate }) {
        return {
          deleteWallComment: (postId, comment) => {
            return mutate({
              variables: { comment: { id: comment.id, postId } }
            });
          }
        };
      }
    }),
    graphql(MUTATION_PIN_WALL_POST, {
      props({ ownProps, mutate }) {
        return {
          pinWallPost: post => {
            return mutate({
              variables: {
                post: { id: post.id },
                posts: { mostRecentLikedByCount: 10, postCount: 1 }
              }
            });
          }
        };
      }
    }),
    graphql(MUTATION_UNPIN_WALL_POST, {
      props({ ownProps, mutate }) {
        return {
          unpinWallPost: post => {
            return mutate({
              variables: { post: { id: post.id } }
            });
          }
        };
      }
    }),
    graphql(MUTATION_LOCK_WALL_POST, {
      props({ ownProps, mutate }) {
        return {
          lockWallPost: post => {
            return mutate({
              variables: {
                post: { id: post.id },
                posts: { mostRecentLikedByCount: 10, postCount: 1 }
              }
            });
          }
        };
      }
    }),
    graphql(MUTATION_UNLOCK_WALL_POST, {
      props({ ownProps, mutate }) {
        return {
          unlockWallPost: post => {
            return mutate({
              variables: { post: { id: post.id } }
            });
          }
        };
      }
    }),
    graphql(MUTATION_LIKE_WALL_POST, {
      props({ ownProps, mutate }) {
        return {
          likePost: post => {
            const storeID = defaultDataIdFromObject(post);

            const storedPost = ownProps.client.readFragment({
              id: storeID,
              fragment: fragments.post,
              fragmentName: 'PostFields',
              variables: QUERY_WALL_POSTS_DEFAULT_VARS
            });
            const user = ownProps.userData.user;

            if (!storedPost.likedByMe) {
              storedPost.likeCount += 1;
              storedPost.likedBy.push(user);
              storedPost.likedByMe = true;

              ownProps.client.writeFragment({
                id: storeID,
                fragment: fragments.post,
                fragmentName: 'PostFields',
                variables: QUERY_WALL_POSTS_DEFAULT_VARS,
                data: storedPost
              });
            }

            return mutate({
              variables: { like: { id: post.id } }
            });
          }
        };
      }
    }),
    graphql(MUTATION_UNLIKE_WALL_POST, {
      props({ ownProps, mutate }) {
        return {
          unlikePost: post => {
            const storeID = defaultDataIdFromObject(post);

            const storedPost = ownProps.client.readFragment({
              id: storeID,
              fragment: fragments.post,
              fragmentName: 'PostFields',
              variables: QUERY_WALL_POSTS_DEFAULT_VARS
            });
            const user = ownProps.userData.user;

            if (storedPost.likedByMe) {
              storedPost.likeCount -= 1;
              storedPost.likedBy = storedPost.likedBy.filter(
                u => u.userId !== user.userId
              );
              storedPost.likedByMe = false;

              ownProps.client.writeFragment({
                id: storeID,
                fragment: fragments.post,
                fragmentName: 'PostFields',
                variables: QUERY_WALL_POSTS_DEFAULT_VARS,
                data: storedPost
              });
            }

            return mutate({
              variables: { unlike: { id: post.id } }
            });
          }
        };
      }
    }),
    graphql(MUTATION_LIKE_COMMENT, {
      props({ ownProps, mutate }) {
        return {
          likeComment: comment => {
            const storeID = defaultDataIdFromObject(comment);
            const storedComment = ownProps.client.readFragment({
              id: storeID,
              fragment: fragments.comment,
              fragmentName: 'CommentFields',
              variables: QUERY_WALL_POSTS_DEFAULT_VARS
            });
            const user = ownProps.userData.user;

            if (!storedComment.likedByMe) {
              storedComment.likeCount += 1;
              storedComment.likedBy.push(user);
              storedComment.likedByMe = true;

              ownProps.client.writeFragment({
                id: storeID,
                fragment: fragments.comment,
                fragmentName: 'CommentFields',
                variables: QUERY_WALL_POSTS_DEFAULT_VARS,
                data: storedComment
              });
            }

            return mutate({
              variables: { like: { id: comment.id, postId: comment.postId } }
            });
          }
        };
      }
    }),
    graphql(MUTATION_UNLIKE_COMMENT, {
      props({ ownProps, mutate }) {
        return {
          unlikeComment: comment => {
            const storeID = defaultDataIdFromObject(comment);
            const storedComment = ownProps.client.readFragment({
              id: storeID,
              fragment: fragments.comment,
              fragmentName: 'CommentFields',
              variables: QUERY_WALL_POSTS_DEFAULT_VARS
            });
            const user = ownProps.userData.user;

            if (storedComment.likedByMe) {
              storedComment.likeCount -= 1;
              storedComment.likedBy = storedComment.likedBy.filter(
                u => u.userId !== user.userId
              );
              storedComment.likedByMe = false;

              ownProps.client.writeFragment({
                id: storeID,
                fragment: fragments.comment,
                fragmentName: 'CommentFields',
                variables: QUERY_WALL_POSTS_DEFAULT_VARS,
                data: storedComment
              });
            }

            return mutate({
              variables: { unlike: { id: comment.id, postId: comment.postId } }
            });
          }
        };
      }
    }),
    graphql(QUERY_GET_REMOTE_CONFIG_ENTRY, {
      name: 'remoteConfigData',
      options: {
        variables: {
          key: CV_WEB_SOCIALPANELTABS_ENABLED
        },
        fetchPolicy: 'cache-and-network'
      },
      props: ({ remoteConfigData }) => {
        return {
          remoteConfigData,
          subscribeToRemoteConfigData: () => {
            return remoteConfigData.subscribeToMore({
              document: REMOTE_CONFIG_EVENT,
              updateQuery: (prev, { subscriptionData }) => {
                if (subscriptionData?.remoteConfigData?.action === 'Update') {
                  subscriptionData?.remoteConfigData?.entries.forEach(
                    ({ key, value }) => {
                      if (key === CV_WEB_SOCIALPANELTABS_ENABLED) {
                        prev.remoteConfigEntry.value = value;
                      }
                    }
                  );
                }
                return prev;
              }
            });
          }
        };
      }
    })
  )(Feed)
);
